import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'theme/index';

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  margin-left: 10px;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
    cursor: pointer;
`;

export const Label = styled.label<{ active: boolean }>`
  margin-left: 15px;
  color: ${({ active }) => (active ? theme.sherpaBlue : theme.grey)};
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  margin-left: auto;
  display: flex;

  button:first-child {
    margin-right: 10px;
  }
`;

export const ToolTipIcon = styled(FontAwesomeIcon)`
  margin-left: 8px;
  cursor: pointer;
  color: ${theme.sherpaBlue};
`;
